// Bahagi ng delivery-picker module set (dating monolitikong
// cart-delivery-picker.js, hinati by-responsibility 2026-08-24 — PURE
// REFACTOR, walang behavior change). Shared namespace:
// window.FlowercartDeliveryPicker (DP); mauna ang delivery-picker-state-config.js
// sa load order.
//
// Saklaw ng file na ito: ang cart network layer — buildCartPayload,
// mergeCartPayload, updateCart + flushCartUpdates queue, ang Standard
// Actions write path (fetchForeignAttributes, toAttributeArray,
// sendCartAttributes) at ang Ajax fallback (postCartUpdateAjax), pati ang
// card-message autosave na nagpapakain sa parehong cart payload.
(function () {
  const DP = (window.FlowercartDeliveryPicker = window.FlowercartDeliveryPicker || {});
  const state = DP.state;

  // Ang tatlong key na PAG-AARI ng widget na ito. Mahalaga ito dahil
  // REPLACE-semantics ang Shopify Standard Actions: ang bawat updateCart ay
  // dapat magdala ng KUMPLETONG attribute set na dapat matapos ang cart —
  // ang anumang key na hindi kasama ay BUBURAHIN. Lahat ng key na wala sa
  // listahang ito ay "foreign" (pag-aari ng ibang app) at kailangang
  // maibalik nang buo sa bawat write.
  //
  // Iba ito sa dating /cart/update.js na MERGE lang — doon, ang mga key na
  // hindi mo binanggit ay hindi nagagalaw.
  const OWNED_ATTRIBUTE_KEYS = ["Delivery Date", "Delivery Time", "Card Message"];

  function debugLog(label, data) {
    if (!window.__deliveryWidgetDebug) return;
    console.log(`[delivery-widget] ${label}`, data);
  }

  function mergeCartPayload(basePayload, nextPayload) {
    const mergedAttributes = Object.assign(
      {},
      basePayload && basePayload.attributes ? basePayload.attributes : {},
      nextPayload && nextPayload.attributes ? nextPayload.attributes : {}
    );

    return Object.assign({}, basePayload || {}, nextPayload || {}, {
      attributes: mergedAttributes
    });
  }

  function buildCartPayload() {
    const { dateInput, timeHidden, cardMessageAttribute } = state.elements;
    const cardMessage = cardMessageAttribute ? cardMessageAttribute.value : "";
    const deliveryDate = dateInput ? dateInput.value : "";
    const deliveryTime = timeHidden ? timeHidden.value : "";

    // P7 2026-08-10: WALANG `note` field dito — ang dating `note: ""` sa bawat
    // /cart/update.js POST ay bubura sa cart note ng kahit anong ibang app
    // (ang delivery-note editor na pinagmulan nito ay retired na, owner call).
    return {
      attributes: {
        "Delivery Date": deliveryDate,
        "Delivery Time": deliveryTime,
        "Card Message": cardMessage
      }
    };
  }

  // Kaparehong version ng ginagamit ng featured-collection load-more sa
  // assets/global.js — panatilihing magkatugma para iisa lang ang babaguhin.
  const STOREFRONT_API_VERSION = "2026-04";

  const FOREIGN_ATTRIBUTES_QUERY =
    "query($id:ID!){cart(id:$id){attributes{key value}}}";

  // Binabasa ang KUMPLETONG cart attribute set at ibinabalik LANG ang mga
  // hindi atin — ang "read" na kalahati ng read-modify-write na kinakailangan
  // ng replace-semantics.
  //
  // BAKIT STOREFRONT API, HINDI /cart.js (sinukat 2026-08-24):
  // Ang private (`__`-prefixed) na cart attributes ay HINDI nakikita sa Ajax
  // API o sa Liquid `cart.attributes` — Storefront API lang ang nakakakita.
  // Ang pagbabasa via /cart.js ay nagbibigay ng di-kumpletong set, at ang
  // pagpapadala ng di-kumpletong set sa replace-semantics na updateCart ay
  // TAHIMIK NA BUMUBURA ng mga hindi nakita. Napatunayan nang live: nag-set
  // ng __private_marker, isang write, wala na.
  //
  // Nagbabalik ng `null` (HINDI `{}`) sa BAWAT failure path. Mahalaga ang
  // pagkakaiba: ang `{}` ay nangangahulugang "walang ibang attribute" at
  // magbubura sa kanila; ang `null` ay "hindi ko nabasa nang buo" at
  // pinipilit ang caller na gamitin ang merge-semantics na Ajax fallback.
  //
  // Ang resulta: ang replace-write ay nangyayari LANG kapag may
  // napatunayang kumpletong set tayo. Walang ibang landas.
  async function fetchForeignAttributes() {
    try {
      const card = state.elements.deliveryCard;
      const token = card ? card.dataset.storefrontToken : "";
      const actions = window.Shopify && window.Shopify.actions;

      if (!token || !actions || typeof actions.getCart !== "function") {
        debugLog("foreign-attributes-read-failed", { reason: "no-token-or-runtime" });
        return null;
      }

      const { cart } = await actions.getCart();
      if (!cart || !cart.id) {
        debugLog("foreign-attributes-read-failed", { reason: "no-cart" });
        return null;
      }

      const response = await fetch(`/api/${STOREFRONT_API_VERSION}/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": token
        },
        body: JSON.stringify({
          query: FOREIGN_ATTRIBUTES_QUERY,
          variables: { id: cart.id }
        })
      });

      if (!response.ok) {
        throw new Error(`Storefront API read failed with status ${response.status}`);
      }

      const json = await response.json();
      if (json.errors) {
        throw new Error(`Storefront API returned errors: ${JSON.stringify(json.errors)}`);
      }

      const attributes = json && json.data && json.data.cart && json.data.cart.attributes;
      if (!Array.isArray(attributes)) {
        debugLog("foreign-attributes-read-failed", { reason: "malformed-response" });
        return null;
      }

      const foreign = {};
      attributes.forEach((attribute) => {
        if (attribute && !OWNED_ATTRIBUTE_KEYS.includes(attribute.key)) {
          foreign[attribute.key] = attribute.value;
        }
      });

      debugLog("foreign-attributes-read", foreign);
      return foreign;
    } catch (error) {
      debugLog("foreign-attributes-read-failed", error);
      return null;
    }
  }

  // Object form ({key: value}) → Standard Actions array form ([{key, value}]).
  //
  // Dalawang bagay ang ginagawa dito na kritikal sa pagpapanatili ng
  // kasalukuyang behavior:
  //   1. String coercion — `String!` ang key at value sa Storefront API.
  //      Ang null/undefined ay malformed payload: nagre-reject ang promise
  //      NANG WALANG shopify:cart:error event, kaya tahimik na failure.
  //   2. Empty-value filter — tinatanggal ng Ajax API ang attribute kapag
  //      blangko ang value (napatunayan sa live orders #4201/#4206: walang
  //      "Card Message" key kapag walang mensahe). Hindi documented ang
  //      Standard Actions dito, kaya tayo na ang nagpapasya: i-drop ang
  //      blangko para hindi lumitaw ang `Card Message: ""` sa mga order.
  function toAttributeArray(owned, foreign) {
    const merged = Object.assign({}, foreign || {}, owned || {});

    return Object.keys(merged)
      .map((key) => ({ key: String(key), value: String(merged[key] ?? "") }))
      .filter((attribute) => attribute.value !== "");
  }

  // Ang Standard Actions write. Nagbabalik ng `null` kapag wala ang runtime
  // para makabalik ang caller sa Ajax path — hindi natin gagawing dead-end
  // ang isang cart write sa isang revenue path.
  async function sendCartAttributes(attributes, trigger) {
    const actions = window.Shopify && window.Shopify.actions;
    if (!actions || typeof actions.updateCart !== "function") return null;

    return actions.updateCart(
      { attributes },
      {
        event: {
          context: "cart",
          detail: { source: "delivery-widget", trigger }
        }
      }
    );
  }

  // Ang orihinal na /cart/update.js POST, buo pa rin. Merge-semantics: ang
  // mga key lang na ipinadala ang nagagalaw. Ito ang fallback kapag hindi
  // ligtas o hindi available ang Standard Actions path.
  async function postCartUpdateAjax(payload, trigger) {
    debugLog("send-ajax-fallback", { trigger, payload });

    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`Cart update failed with status ${response.status}`);
    }

    return response.json();
  }

  async function updateCart(payload, trigger) {
    state.pendingCartPayload = mergeCartPayload(
      state.pendingCartPayload,
      payload || buildCartPayload()
    );

    if (trigger) state.pendingTrigger = trigger;

    return new Promise((resolve) => {
      state.pendingUpdateResolves.push(resolve);

      if (state.isUpdating) return;

      void flushCartUpdates();
    });
  }

  // Sinasadyang HINDI ginagamit ang AbortSignal na inirerekomenda ng Shopify
  // para sa rapid successive calls. Sa replace-semantics, ang na-abort na
  // write na dumating nang huli ay pwedeng magbura ng mas bagong set —
  // walang ordering guarantee ang runtime. Ang serialize-then-send-latest
  // na queue na ito ay walang ganoong window: isang write lang ang nasa
  // ere sa isang pagkakataon, at laging ang pinakabagong payload ang
  // ipinapadala.
  async function flushCartUpdates() {
    state.isUpdating = true;
    let didSucceed = true;

    try {
      while (state.pendingCartPayload) {
        const nextPayload = state.pendingCartPayload;
        const trigger = state.pendingTrigger || "unknown";
        state.pendingCartPayload = null;
        state.pendingTrigger = null;

        const foreign = await fetchForeignAttributes();

        // Hindi nabasa ang kasalukuyang attributes → hindi tayo makakabuo
        // ng kumpletong set, at ang di-kumpletong set ay magbubura ng
        // hindi natin nakita. Ang merge-semantics na Ajax path ang ligtas.
        if (foreign === null) {
          await postCartUpdateAjax(nextPayload, trigger);
          continue;
        }

        const attributes = toAttributeArray(nextPayload.attributes, foreign);
        debugLog("send-standard-action", { trigger, attributes });

        const result = await sendCartAttributes(attributes, trigger);

        // Wala ang Standard Actions runtime → Ajax fallback.
        if (result === null) {
          await postCartUpdateAjax(nextPayload, trigger);
          continue;
        }

        // Tandaan: ang userErrors ay nangangahulugang TINANGGIHAN ang
        // pagbabago (hindi nagbago ang cart). Ang warnings ay
        // nangangahulugang NAGBAGO ang cart pero may babala.
        if (result.userErrors && result.userErrors.length) {
          debugLog("user-errors", result.userErrors);
          console.error("Cart attribute update rejected:", result.userErrors);
          didSucceed = false;
        }

        if (result.warnings && result.warnings.length) {
          debugLog("warnings", result.warnings);
        }

        debugLog("send-ok", { trigger, handledBy: result.detail && result.detail.handledBy });
      }
    } catch (err) {
      didSucceed = false;
      console.error("Cart update error:", err);
    } finally {
      state.isUpdating = false;
      const resolves = state.pendingUpdateResolves.splice(0, state.pendingUpdateResolves.length);
      resolves.forEach((resolve) => resolve(didSucceed));
    }
  }

  function bindCardMessageAutosave() {
    const { cardMessageInput, cardMessageAttribute } = state.elements;

    if (cardMessageInput && !cardMessageInput.dataset.deliveryBound) {
      if (cardMessageAttribute) {
        cardMessageAttribute.value = cardMessageInput.value.slice(0, 300);
      }

      cardMessageInput.addEventListener("input", () => {
        if (cardMessageInput.value.length > 300) {
          cardMessageInput.value = cardMessageInput.value.slice(0, 300);
        }

        if (cardMessageAttribute) {
          cardMessageAttribute.value = cardMessageInput.value;
        }
      });

      cardMessageInput.addEventListener("blur", () => {
        void updateCart(buildCartPayload(), "card-message");
      });

      cardMessageInput.dataset.deliveryBound = "true";
    }
  }

  DP.buildCartPayload = buildCartPayload;
  DP.updateCart = updateCart;
  DP.bindCardMessageAutosave = bindCardMessageAutosave;
})();
